import { render, staticRenderFns } from "./activityCreateTest.html?vue&type=template&id=55f377ce&external"
import script from "./activityCreateTest.vue?vue&type=script&lang=js"
export * from "./activityCreateTest.vue?vue&type=script&lang=js"
import style0 from "./activityCreateTest.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports